import DefaultLogoImageRS from '@/assets/icons/logo-rs.svg';
import DefaultLogoImage from '@/assets/icons/logo.svg';
import { Image } from '@/components';

import type { FC } from 'react';

type Props = {
  onClick?: () => void;
};

export const LogoImage: FC<Props> = ({ onClick }) => {
  return (
    <Image
      src={DefaultLogoImageRS}
      fallback={DefaultLogoImage}
      width={150}
      alt="logo image"
      preview={false}
      onClick={onClick}
      style={{
        cursor: 'pointer',
      }}
    />
  );
};
